/*global swfobject */
define('all/player/security',['jquery', 'all/navigation'], function($, navigation) {
	'use strict';

	var FLASH_ID = 'swftopnav';

	$(function() {

		var $hiddenFlash = $('#hidden-flash');
		if ($hiddenFlash.length === 0) {
			$hiddenFlash = $('<div>', {
				id: 'hidden-flash'
			});
			$(document.body).append($hiddenFlash);
		}

		var $div = $('<div>');
		$div.attr('id', FLASH_ID);
		$hiddenFlash.append($div);

		var attributes = {
			id: FLASH_ID,
			name: FLASH_ID,
			style: 'position: absolute;'
		};

		var flashvars = {
			baseUrl: navigation.baseURL + '/pp'
		};

		var params = {
			menu: 'false',
			allowscriptaccess: 'always',
			wmode: 'transparent'
		};

		swfobject.embedSWF(
			navigation.staticURL('flash/FlashData.swf'),
			FLASH_ID,
			'1', '1', '10',
			navigation.staticURL('flash/expressInstall.swf'),
			flashvars,
			params,
			attributes
		);
	});

	function getDeviceId() {
		var topnav = swfobject.getObjectById(FLASH_ID);
		if(topnav) {
            try{
                return topnav.getDid();
            } catch (err) {
                console.error(err);
                return -1;
            }
		} else {
			console.warn('No flash object "' + FLASH_ID + '", cannot get device id');
			return -1;
		}
	}

	window.security = {
		getDeviceId: getDeviceId
	};

	return window.security;
});

